module.exports = __webpack_public_path__ + "img/softinya-9.53b41f30.png";